<template>
    <div v-if="data">
        <vs-card class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Background Pick</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            ID
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-1/3">
                            Reference*
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input class="w-full" v-model="data.reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/4 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Movement Date*
                        </div>
                        <div class="vx-col w-2/3">
                            <flat-pickr class="w-full" v-model="data.movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-table multiple v-model="selected" :data="data.draft" stripe hoverFlat pagination max-items="20">
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        {{ tr.line_id }}
                    </vs-td>

                    <vs-td>
                        {{ tr.product_code }}
                    </vs-td>

                    <vs-td>
                        {{ tr.description_1 }}
                    </vs-td>

                    <vs-td>
                        {{ tr.pack_id }}
                    </vs-td>

                    <vs-td>
                        {{ tr.batch }}
                    </vs-td>

                    <vs-td>
                        {{ tr.expired_date }}
                    </vs-td>
                    
                    <vs-td>
                        {{ tr.base_qty }}
                    </vs-td>

                   <vs-td>
                        {{ tr.base_uom }}
                    </vs-td>

                    <vs-td>
                        {{ tr.stock_type }}
                    </vs-td>

                    <vs-td>
                        {{ tr.location_type }}
                    </vs-td>

                    <vs-td>
                        {{ tr.location_code }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    props: {
        type2: {
            type: String
        },
        type: {
            type: String
        }
    },
    data() {
        return {
            data: null,
            selected: [],
            isLoading: false,
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        back() {
            let name = null;
            let id = this.$route.params.id
            if(this.$props.type == 'delivery_order') {
                name = 'delivery-order-view';
            }
            else if(this.$props.type == 'vas') {
                if(this.$props.type2 == 'production-order') {
                    name = 'production-order-view'
                }
            }
            
            this.$router.push({
                name: name,
                params: {
                    id: id
                }
            });
        },
        submitForm() {
            let error = false
            let url = null;

            if(this.$props.type == 'delivery_order') {
                url = 'outbound/deliveryorder/savepicklist';
            }
            else if(this.$props.type == 'production_order') {
                url = 'valueaddedservice/productionorder/savepicklist';
            }
            else if(this.$props.type == 'good_receive') {
                url = 'inbound/goodreceive/reverse/pick';
            }
            else if(this.$props.type == 'vas') {
                url = 'valueaddedservice/savepickdraft';
            }

            let details = []

            if(!this.selected.length) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No data selected'
                });
                
                return false
            }

            this.selected.map(item => {
                if(!item.location_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + ' - No location assigned'
                    })

                    error = true
                }
                else {
                    if(item.draft_ids) {
                        const ids = item.draft_ids.split(',');
                        details = [...details, ...ids];
                    }
                    else {   
                        details.push(item.id)
                    }
                }
            });

            if(error) {
                return false
            }
            else {
                this.isLoading = true

                const dataSend = {
                    id: this.$route.params.id,
                    movement_date: this.data.movement_date,
                    details: details
                }

                this.$http.post(url, dataSend)
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully'
                    })
                    this.back();
                })
                .catch(error => this.handleError(error))
            }
        },
        removeLine() {
            let indexes = []
            this.selected.map(selected => {
                this.data.details.map((detail, index) => {
                    if(selected.line_id == detail.line_id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)
            indexes.map(i => this.data.details.splice(i, 1))
            this.selected = []
            this.generateLineId()
        },
        generateLineId() {
            this.data.details.map((item, index) => item.line_id = index + 1)
        }
    },
    mounted() {        
        if(!this.$route.params.data) {
            return this.$router.go(-1);
        }

        this.$route.params.data.draft.map((d, i) => d.line_id = i + 1)

        this.data = this.$route.params.data
        
        this.data.movement_date = new Date()
        this.selected = this.$_.filter(this.data.draft, 'inventory_id');

        setTimeout(() => {
            this.$vs.loading.close()
        }, 300)
    }
}
</script>